import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=58176232&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=58176232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58176232",
  null
  
)

export default component.exports